import { AxiosError } from 'axios';

class WalletAlpha {
  static messages: Record<WalletAlphaMessage, WalletAlphaMessage> = {
    NUVEM_LOGIN_SUCCESS: 'NUVEM_LOGIN_SUCCESS',
    NUVEM_CLEAR_INPUTS: 'NUVEM_CLEAR_INPUTS',
    NUVEM_INITIALIZE: 'NUVEM_INITIALIZE',
    NUVEM_READY: 'NUVEM_READY',
    NUVEM_AUTH_DATA_READY: 'NUVEM_AUTH_DATA_READY',
    NUVEM_LOGIN_FAILURE: 'NUVEM_LOGIN_FAILURE',
    NUVEM_LOGGED_USER: 'NUVEM_LOGGED_USER',
    NUVEM_LOGOUT: 'NUVEM_LOGOUT',
    NUVEM_CLEAR_AUTH_DATA: 'NUVEM_CLEAR_AUTH_DATA',
    NUVEM_CHANGE_OTP_CHANNEL: 'NUVEM_CHANGE_OTP_CHANNEL',
    NUVEM_CREATE_ORDER: 'NUVEM_CREATE_ORDER',
    NUVEM_GET_SHOW_ONE_TAP_SURVEY: 'NUVEM_GET_SHOW_ONE_TAP_SURVEY',
    NUVEM_SHOW_ONE_TAP_SURVEY: 'NUVEM_SHOW_ONE_TAP_SURVEY',
    NUVEM_UPDATE_ADDRESS: 'NUVEM_UPDATE_ADDRESS',
    NUVEM_FETCH_ADDRESS: 'NUVEM_FETCH_ADDRESS',
    NUVEM_SET_AUTHORIZATION: 'NUVEM_SET_AUTHORIZATION',
    NUVEM_SEND_CES: 'NUVEM_SEND_CES',
    NUVEM_REFRESH_TOKEN: 'NUVEM_REFRESH_TOKEN',
    NUVEM_SEND_OTP_RECEIVED: 'NUVEM_SEND_OTP_RECEIVED',
    NUVEM_UPDATE_USER: 'NUVEM_UPDATE_USER',
    NUVEM_LOGIN: 'NUVEM_LOGIN',
    NUVEM_SESSION_MIGRATION: 'NUVEM_SESSION_MIGRATION',
  };

  static postMessage = (message: WalletAlphaMessage, data: unknown, origin: string) => {
    window.parent.postMessage({ message, data }, origin);
  };

  static parseMessage = <T>(event: MessageEvent): WalletAlphaMessageData<T> | undefined => {
    try {
      return JSON.parse(event.data) as WalletAlphaMessageData<T>;
    } catch (error: unknown) {
      // ignoring other messages for now
      return undefined;
    }
  };

  static postErrorForMessage = (message: WalletAlphaMessage, error: unknown, origin: string) => {
    let errorToSend: string;

    const axiosError = error as AxiosError;
    if (axiosError.request || axiosError.response) {
      errorToSend = JSON.stringify(
        axiosError.response ?? { error: axiosError.message, status: axiosError.request.status }
      );
    } else {
      errorToSend = JSON.stringify(error, Object.getOwnPropertyNames(error));
    }

    window.parent.postMessage({ message, error: errorToSend }, origin);
  };
}

export default WalletAlpha;
